var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uk-modal", attrs: { id: _vm.modalName + "-modal" } },
    [
      _c("div", { staticClass: "uk-modal-dialog uk-modal-dialog-large" }, [
        _c("span", { staticClass: "uk-modal-close uk-close" }),
        _vm.hasHeader
          ? _c("div", { staticClass: "uk-modal-header" }, [
              _c(
                "h3",
                {
                  staticStyle: { border: "none" },
                  attrs: { id: _vm.modalName + "-modal-header" },
                },
                [_vm._t("title")],
                2
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "uk-overflow-container",
            attrs: { id: _vm.modalName + "-modal-content" },
          },
          [_vm._t("default")],
          2
        ),
        _vm.hasFooter
          ? _c("div", { staticClass: "uk-modal-footer" }, [
              _c(
                "div",
                { staticClass: "footer-content" },
                [_vm._t("footer")],
                2
              ),
              _c("div", { staticClass: "print-block" }, [
                _c(
                  "span",
                  {
                    staticClass: "print-save uk-button",
                    attrs: {
                      id: _vm.modalNameShort + "-modal-print",
                      title: _vm.printTitle,
                    },
                    on: { click: _vm.print },
                  },
                  [_c("i", { class: _vm.printIcon }), _vm._v(" Распечатать")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "pdf-save uk-button uk-button-primary",
                    attrs: {
                      id: _vm.modalNameShort + "-modal-save",
                      title: _vm.saveTitle,
                    },
                    on: { click: _vm.save },
                  },
                  [
                    _c("i", {
                      class:
                        ((_obj = {}),
                        (_obj[_vm.saveIcon] = !_vm.saveLoading),
                        (_obj["uk-icon-spinner"] = _vm.saveLoading),
                        (_obj["uk-icon-spin"] = _vm.saveLoading),
                        _obj),
                    }),
                    _vm._v(" Сохранить PDF"),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }